import { Box, IconButton, Tooltip, Button } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { Delete, Edit, FileDownload } from "@mui/icons-material";
import { Accessibility } from "../component";
import { useMemo } from "react";

export default function RetailerTable({
  data,
  loading,
  onEdit,
  onDelete,
  FEATURES,
  handleExportRetailerData,
}) {
  const columns = useMemo(
    () => [
      {
        accessorKey: "retailer_id",
        header: "ID",
        size: 50,
      },
      {
        accessorKey: "retailer_name",
        header: "Retailer Name",
        size: 150,
      },
      {
        accessorKey: "display_text",
        header: "Display Text",
        size: 150,
      },
      {
        accessorKey: "country_code",
        header: "Country Code",
        size: 100,
      },
      // {
      //   accessorKey: "retailer_type",
      //   header: "Retailer Type",
      //   size: 100,
      // },
    ],
    [],
  );
  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      state={{ showSkeletons: loading || !data?.length }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: "#1976d2",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "14px",
        },
      }}
      renderTopToolbarCustomActions={({ table }) => (
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <Button
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={handleExportRetailerData}
            startIcon={<FileDownload />}
          >
            Export CSV
          </Button>
        </Box>
      )}
      enableRowActions
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          <Tooltip title="Edit">
            <IconButton color="primary" onClick={() => onEdit(row?.original)}>
              <Accessibility feature={FEATURES.MANAGE_RETAILER_DETAILS}>
                <Edit />
              </Accessibility>
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <IconButton color="error" onClick={() => onDelete(row?.original)}>
              <Accessibility feature={FEATURES.MANAGE_RETAILER_DETAILS}>
                <Delete />
              </Accessibility>
            </IconButton>
          </Tooltip>
        </Box>
      )}
    />
  );
}
